module.exports = __webpack_public_path__ + "img/while-learning.60211ec3.png";